/**
 * Analytics helpers. GA is loaded by Analytics component when
 * NEXT_PUBLIC_GA_MEASUREMENT_ID is set.
 */
declare global {
  interface Window {
    gtag?: (
      command: "event" | "config",
      targetId: string,
      params?: Record<string, unknown>
    ) => void;
  }
}

export function trackEvent(
  name: string,
  params?: Record<string, string | number | boolean>
) {
  if (typeof window !== "undefined" && window.gtag && process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID) {
    window.gtag("event", name, params);
  }
}
